import {Alert, DialogContent, DialogTitle, Table, TableBody, TableCell, TableRow} from "@mui/material";
import {Link} from "react-router-dom";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {LogiCtrlExistingItem} from "../../../../api/LogiCtrl";
import {api} from "../../../../api/API";
import {useBackgroundAction} from "../../manage/sov/UseBackgroundTask";
import moment from "moment";

export function poStatusDisplay(status: string | null) {
    if(status === "price-request") return "price request";
    return status || "";
}

export function PoModifyReviewDialog(props: {
    project: number;
    item: LogiCtrlExistingItem;
    onClose(approved: boolean): void;
}) {
    const project = props.project;
    const item = props.item;
    const isPriceRequest = item.purchaseOrderStatus === "price-request";

    const approve = useBackgroundAction<Parameters<typeof api.logiCtrl.setPoModifyApproval>[0], any>({
        callback: async (input) => api.logiCtrl.setPoModifyApproval(input),
        onDone: () => props.onClose(true),
    });

    return (
        <Dialog2 open onClose={() => props.onClose(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Review {item.purchaseOrder ? "PO change" : "released item change"}</DialogTitle>
            <DialogContent>
                <div style={{marginBottom: 12}}>
                    <b>{item.name}</b> (qty {item.qty}, {item.openingName || "no opening"}) is currently <b>{item.purchaseOrder ? "on a purchase order" : "released"}</b>.
                </div>

                {item.purchaseOrder && <Table size="small" style={{marginBottom: 12}}>
                    <TableBody>
                        <TableRow>
                            <TableCell>PO</TableCell>
                            <TableCell>
                                <Link target="_blank" to={`/logistics/purchasing/${item.purchaseOrder}`}>PO #{item.purchaseOrderNumber}</Link>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Status</TableCell>
                            <TableCell>{poStatusDisplay(item.purchaseOrderStatus)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Supplier</TableCell>
                            <TableCell>{item.purchaseOrderSupplierName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Target date</TableCell>
                            <TableCell>{item.purchaseOrderTargetDate ? moment(item.purchaseOrderTargetDate).format("YYYY-MM-DD") : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Lines</TableCell>
                            <TableCell>{item.purchaseOrderLineCount}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>This line</TableCell>
                            <TableCell>{item.purchaseOrderItemDescription} (qty {item.purchaseOrderItemQty})</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>}

                <div style={{marginBottom: 12}}>
                    When this change is applied the system will:
                    <ol style={{marginTop: 4, marginBottom: 4}}>
                        {isPriceRequest && <li>Set PO #{item.purchaseOrderNumber} back to <b>draft</b></li>}
                        {item.purchaseOrder && <li>Remove this item from the PO</li>}
                        <li>Unrelease this item and replace it with the recalculated item</li>
                        <li>Release the replacement (keeping the needed-by date)</li>
                        {item.purchaseOrder && <li>Add the replacement to the PO draft</li>}
                    </ol>
                    If the recalculation has no replacement for this item, the item is removed{item.purchaseOrder ? " from the PO" : ""}.
                </div>

                {isPriceRequest && <Alert severity="warning">
                    PO #{item.purchaseOrderNumber} is a <b>price request</b>. Approving reverts it to draft, which invalidates the price request. The PO must be re-sent to the supplier.
                </Alert>}
            </DialogContent>
            <SmoothActionBar
                loading={approve.loading}
                error={approve.error}
                onCancel={() => props.onClose(false)}
                onSubmit={() => approve.callback({
                    project: project,
                    ids: [item.id],
                    approved: true,
                })}
                actionName={isPriceRequest ? "Approve (revert to draft)" : "Approve"}
            />
        </Dialog2>
    )
}
